module.exports = __webpack_public_path__ + "images/chrysler_smalld6a955fca3a6e5d7975a6a8d25bde501.png";